import type { IPixPolygon } from "@multiconsult-group/multiplacer-ui";

export const COMPONENT_SEARCH_CONTEXT_OPACITY = 0.12;

/** Temporary 2D presentation; never changes the saved view or 3D opacity. */
export function applyComponentSearchAppearance(polygons: IPixPolygon[], hits: Set<string> | null, selectedId?: string | null): IPixPolygon[] {
  if (hits === null) return polygons;
  return polygons.map(polygon => {
    const id = polygon.entityId;
    if (id != null && hits.has(id)) {
      return {
        ...polygon,
        opacity: 1,
        outline: {
          color: id === selectedId ? "#dc2626" : "#862e9c",
          backgroundColor: "#ffffff",
          width: 3,
          dashArray: [3, 2],
        },
      };
    }
    return { ...polygon, opacity: Math.min(polygon.opacity ?? 1, COMPONENT_SEARCH_CONTEXT_OPACITY) };
  });
}
